import { useCallback } from 'react';
import {
  useEngineInstance,
  useSubjectId
} from '@surveycake/react-logic-engine';
import { Message } from '@surveycake/rc';
import { Wording } from '@surveycake/wording/survey';

export function useTimerTrigger(wording: Wording) {
  const engine = useEngineInstance();
  const id = useSubjectId();
  const startTimer = useCallback(() => {
    engine.startTimer(id);

    if (engine.getSubjectData(id).youtubeid) {
      Message.info(wording.module.timer.playcountdown, { duration: 2000 });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [engine, id]);
  return startTimer;
}
